import ProfessionalInfo from './ProfessionalInfo';

export default ProfessionalInfo;